export default __webpack_public_path__ + "static/media/btn_edit_user.287e8f96.svg";